import { createSearchParams, useNavigate } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoProps } from 'pages/compra/pedido/types';

export function useQueryTotalizador({ configPedido }: { configPedido?: ConfigPedidoProps }) {
    const requestListagem = useRequestListagem();
    const navigate = useNavigate();

    return useQuery({
        queryKey: ['config-pedido-totalizador', configPedido?.idConfigPedidoOrigem],
        queryFn: () =>
            requestListagem({
                url: '/gestao/configpedido/totalizador',
                filter: [{ property: 'idConfigPedido', operator: 'eq', value: configPedido?.idConfigPedidoOrigem }],
                sort: [{ property: 'idConfigPedido', direction: 'ASC' }],
            }).then((res) => res.data),

        enabled: Boolean(configPedido),
        onSuccess: (response) => {
            const [{ configPedido: configPedidoTotalizadora, configPedidoRelacionada, fgSincronizado }] = response.data;
            const { dtInicioVigencia, dtFimVigencia, dsConfigPedido, idConfigPedido } = configPedidoTotalizadora;

            navigate({
                pathname: '/compra/pedido-totalizador',
                search: createSearchParams({
                    idConfigPedidoOrigem: JSON.stringify([
                        { configPedido: { dsConfigPedido, idConfigPedido }, configPedidoRelacionada, fgSincronizado },
                    ]),
                    idConfigPedido: JSON.stringify([{ idConfigPedido: configPedido?.idConfigPedido, dsConfigPedido: configPedido?.dsConfigPedido }]),
                    idStatusPedidoTotalizador: JSON.stringify([{ idStatusPedidoTotalizador: 5, dsStatusPedidoTotalizador: 'Refazer Quebras' }]),
                    dhInclusao: JSON.stringify({
                        startDate: new Date(`${dtInicioVigencia}T00:00:00`),
                        endDate: new Date(`${dtFimVigencia}T00:00:00`),
                    }),
                }).toString(),
            });
        },
    });
}
